import { VersionGame } from '../../../../../models';

export class ContestView {
  id: string;
  name: string;
  isNinthAge: boolean;
  isEssenceOfWar: boolean;
  isWarhammerBattle: boolean;

  constructor(params: ContestViewParams) {
    this.id = params.id;
    this.name = params.name;

    this.isNinthAge = params.game === VersionGame.NinthAge;
    this.isEssenceOfWar = params.game === VersionGame.EssenceOfWar;
    this.isWarhammerBattle = params.game === VersionGame.WarhammerBattle;
  }
}

export type ContestViewParams = {
  id: string;
  name: string;
  game: VersionGame;
};
